export const initialState = {
  recommendations: [],
  isFetching: false,
}

export const setRecommendations = (state, payload) => (
  { ...state, recommendations: payload, isFetching: false }
)

export const setFetching = (state, payload) => (
  { ...state, isFetching: payload }
)
